/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerformanceStatistics } from './PerformanceStatistics';
import {
    PerformanceStatisticsFromJSON,
    PerformanceStatisticsFromJSONTyped,
    PerformanceStatisticsToJSON,
    PerformanceStatisticsToJSONTyped,
} from './PerformanceStatistics';

/**
 * 
 * @export
 * @interface PlayerPerformanceStatistic
 */
export interface PlayerPerformanceStatistic {
    /**
     * 
     * @type {string}
     * @memberof PlayerPerformanceStatistic
     */
    playerId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerPerformanceStatistic
     */
    playerName?: string;
    /**
     * 
     * @type {number}
     * @memberof PlayerPerformanceStatistic
     */
    playerNumber?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerPerformanceStatistic
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerPerformanceStatistic
     */
    teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerPerformanceStatistic
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerPerformanceStatistic
     */
    categoryName?: string;
    /**
     * 
     * @type {number}
     * @memberof PlayerPerformanceStatistic
     */
    matchesPlayed?: number;
    /**
     * 
     * @type {PerformanceStatistics}
     * @memberof PlayerPerformanceStatistic
     */
    statistics?: PerformanceStatistics;
}

/**
 * Check if a given object implements the PlayerPerformanceStatistic interface.
 */
export function instanceOfPlayerPerformanceStatistic(value: object): value is PlayerPerformanceStatistic {
    return true;
}

export function PlayerPerformanceStatisticFromJSON(json: any): PlayerPerformanceStatistic {
    return PlayerPerformanceStatisticFromJSONTyped(json, false);
}

export function PlayerPerformanceStatisticFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerPerformanceStatistic {
    if (json == null) {
        return json;
    }
    return {
        
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'playerName': json['playerName'] == null ? undefined : json['playerName'],
        'playerNumber': json['playerNumber'] == null ? undefined : json['playerNumber'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'matchesPlayed': json['matchesPlayed'] == null ? undefined : json['matchesPlayed'],
        'statistics': json['statistics'] == null ? undefined : PerformanceStatisticsFromJSON(json['statistics']),
    };
}

export function PlayerPerformanceStatisticToJSON(json: any): PlayerPerformanceStatistic {
    return PlayerPerformanceStatisticToJSONTyped(json, false);
}

export function PlayerPerformanceStatisticToJSONTyped(value?: PlayerPerformanceStatistic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'playerId': value['playerId'],
        'playerName': value['playerName'],
        'playerNumber': value['playerNumber'],
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'categoryId': value['categoryId'],
        'categoryName': value['categoryName'],
        'matchesPlayed': value['matchesPlayed'],
        'statistics': PerformanceStatisticsToJSON(value['statistics']),
    };
}

